// extracted by mini-css-extract-plugin
export default {"wrapper":"ImgBox_wrapper__MaZ37","imgArea":"ImgBox_imgArea__vkErW"};